export default __webpack_public_path__ + "static/media/prescription.379de3a8.svg";